import { useMutation } from '@tanstack/react-query'

import { resetQueries } from '@/utils'

import { visitorParkingAPI } from '../new-api'
import { getVisitorParkingSessionQueryKey } from './get-visitor-parking-session'

interface ExtendVisitorParkingSessionRequest {
  ticketNumber: string
  duration: number
}

interface ExtendVisitorParkingSessionResponse {
  sessionId: number
  ticketNumber: string
  amount: number
  clientSecret: string | null
  visitorId: number
  duration: number
}

export const extendVisitorParkingSession = async (data: ExtendVisitorParkingSessionRequest) => {
  const response = await visitorParkingAPI.post<ExtendVisitorParkingSessionResponse>(
    `/visitor-parking/extend-session`,
    data,
  )
  return response.data
}

export const useExtendVisitorParkingSession = (ticketNumber: string) => {
  return useMutation({
    mutationFn: extendVisitorParkingSession,
    onSuccess: () => {
      // Note: When session is extended the endDate is updated. This will invalidate the query and refetch the session.

      resetQueries(getVisitorParkingSessionQueryKey({ ticketNumber }))
    },
  })
}
